import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRole } from "@/data/RoleContext";
import { usePermissions } from "@/data/PermissionsContext";
import { ROLE_DEFAULT_ROUTES, isRouteAllowed } from "@/data/rolePermissions";
import { isPermittedRoute } from "@/data/permissionsMapping";

export function RoleRouteGuard() {
  const { role } = useRole();
  const { hasPermission, loading } = usePermissions();
  const location = useLocation();
  const navigate = useNavigate();
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (loading) return;
    if (redirectedRef.current) return;

    const pathname = location.pathname;
    if (pathname === "/" || pathname === "") return;

    // isPermittedRoute checks the dynamic permissions registry (PERMISSIONS + ROUTE_PERMISSION_ALIASES).
    // isRouteAllowed checks the static ROLE_ALLOWED_ROUTES list in rolePermissions.ts.
    // Some routes (e.g. /intake-review) are only in the static list — either check passing is sufficient.
    const permitted = isPermittedRoute(hasPermission, pathname) || isRouteAllowed(role, pathname);
    if (!permitted) {
      redirectedRef.current = true;
      const fallback = ROLE_DEFAULT_ROUTES[role] ?? "/";
      navigate(fallback, { replace: true });
    }
  }, [loading, hasPermission, location.pathname, navigate, role]);

  return null;
}
